import { useQuery } from "@tanstack/react-query";
import { productService } from "../services/product.service";
import React from "react";

export function useProducts(isEnabled: boolean) {
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: ["products"],
    queryFn: () => productService.getProducts(),
    enabled: isEnabled,
  });

  React.useEffect(() => {
    if (isError) {
      console.error("Error fetching data:", error);
    }
  }, [isError, error]);

  return { data, isLoading, isError, error };
}
